import React from 'react';
import {
  ResponsiveContainer, BarChart, Bar, XAxis, YAxis,
} from 'recharts';
import PropTypes from 'prop-types';

const NWHorizontalBarChart = ({ data, containerWidth, containerHeight }) => {
  const customLabel = ({
    x, y, value, width, height, offset,
  }) => (
    <text
      x={width + x + offset}
      y={y + height / 2}
      width={width}
      height={height}
      fill="#757679"
      fontSize="12"
      className="recharts-text recharts-label"
      textAnchor="start"
    >
      <tspan x={width + x + offset} dy="0.355em">{`${(value).toFixed(2)}%`}</tspan>
    </text>
  );
  return (
    <ResponsiveContainer width={containerWidth} height={containerHeight}>
      <BarChart
        data={data}
        layout="vertical"
        barGap={16}
        barSize={16}
        barCategoryGap={16}
        margin={{
          top: 5, right: 35, left: 5, bottom: 5,
        }}
      >
        <XAxis type="number" hide />
        <YAxis type="category" dataKey="name" width={80} />
        <Bar
          dataKey="value"
          fill="#82C3BD"
          label={customLabel}
        />
      </BarChart>
    </ResponsiveContainer>
  );
};

NWHorizontalBarChart.propTypes = {
  // The source data which each element is an object.
  data: PropTypes.arrayOf(PropTypes.object),
  // The width of chart container.
  containerWidth: PropTypes.string,
  // The height of chart container.
  containerHeight: PropTypes.string,
};

NWHorizontalBarChart.defaultProps = {
  data: [
    { name: 'Category 1', value: 10 },
    { name: 'Category 2', value: 20 },
    { name: 'Category 3', value: 30 },
  ],
  containerWidth: '100%',
  containerHeight: '100%',
};

export default NWHorizontalBarChart;
